var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientDevelopmentCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 250,
    viewBox: "0 0 400 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.25H375C388.669 0.25 399.75 11.331 399.75 25V225C399.75 238.669 388.669 249.75 375 249.75H25C11.331 249.75 0.25 238.669 0.25 225V25C0.25 11.331 11.331 0.25 25 0.25Z",
    fill: "black",
    stroke: "url(#paint0_linear_308_1287)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0591 240.389H217.059C263.459 240.389 227.392 216.723 203.559 204.889C178.892 198.556 128.459 171.089 124.059 111.889C119.659 52.6893 39.5591 70.556 0.0591125 86.8893C0.559113 111.056 1.25911 166.989 0.0591125 197.389C-1.14088 227.789 16.2258 238.723 25.0591 240.389Z",
    fill: "url(#paint1_linear_308_1287)",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_1287",
    x1: 209,
    y1: 34.5,
    x2: 66.7267,
    y2: 73.1329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_308_1287",
    x1: 143.059,
    y1: 239.889,
    x2: -37.9409,
    y2: 130.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientDevelopmentCard);
export default __webpack_public_path__ + "static/media/gradient-development-card.faeb8bea4efed5e604ec57c091d4dfdf.svg";
export { ForwardRef as ReactComponent };